import { useEffect, useRef } from "react";

import { MESSAGE_TYPE_DICT, useMessagesContext } from "app/contexts/MessagesContext/MessagesContext";
import { GaTriggerContainer } from "app/modules/ga-connect";

export const GaConnectMessageListener = () => {
    const { register } = useMessagesContext();
    const openRef = useRef<() => void>(() => {});

    useEffect(() => {
        if (!register) {
            return;
        }

        return register(MESSAGE_TYPE_DICT.openGaConnect, () => {
            openRef.current();
        });
    }, [register]);

    return (
        <GaTriggerContainer>
            {({ open }) => {
                openRef.current = open;

                return <></>;
            }}
        </GaTriggerContainer>
    );
};
